import React from 'react';
import { ArrowRightIcon, ZapIcon, CheckCircleIcon, LockIcon, BanknoteIcon } from 'lucide-react';
import { getHotmartUrl, handleCheckoutClick } from '../utils/utmParams';
export function FinalCTA() {
  const paymentIcons = [{
    label: 'VISA',
    color: 'text-blue-300'
  }, {
    label: 'PayPal',
    color: 'text-blue-200'
  }, {
    label: 'AMEX',
    color: 'text-blue-300'
  }, {
    label: 'Venmo',
    color: 'text-blue-200'
  }];
  const doubledIcons = [...paymentIcons, ...paymentIcons];
  return <section className="bg-forest-dark py-12 md:py-16 px-5" data-id="element-172">
      <div className="max-w-2xl mx-auto text-center" data-id="element-173">
        {/* Headline */}
        <h2 className="font-serif text-white text-3xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-174">
          Your Garden Won't Wait.
          <br data-id="element-175" />
          Neither Should You.
        </h2>

        {/* Body */}
        <p className="font-sans text-white/80 leading-relaxed mb-10 text-base md:text-lg max-w-xl mx-auto" data-id="element-176">
          The next frost doesn't send a warning. The next heat wave doesn't ask
          permission. For $6.37 — less than a cup of coffee — you can have a
          complete protection system ready for every season, every storm, every
          extreme weather event.
        </p>

        {/* Final CTA — RED HEARTBEAT */}
        <a href={getHotmartUrl()} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="cta-heartbeat inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white text-lg font-bold py-5 px-12 rounded-lg shadow-lg transition-colors duration-200 mb-6" data-id="element-177">
          <span data-id="element-178">🛡️</span>
          <span data-id="element-179">CLAIM MY GARDEN SHIELD SYSTEM — $6.37</span>
          <ArrowRightIcon className="w-5 h-5" data-id="element-180" />
        </a>

        {/* Gold Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-6" data-id="element-181">
          <div className="flex items-center gap-1.5 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-3.5 py-1.5" data-id="element-182">
            <ZapIcon className="w-3.5 h-3.5 text-yellow-400" data-id="element-183" />
            <span className="text-yellow-300 text-xs font-semibold font-sans" data-id="element-184">
              Instant Access
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-3.5 py-1.5" data-id="element-185">
            <LockIcon className="w-3.5 h-3.5 text-yellow-400" data-id="element-186" />
            <span className="text-yellow-300 text-xs font-semibold font-sans" data-id="element-187">
              Bank-Level Security
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-3.5 py-1.5" data-id="element-188">
            <CheckCircleIcon className="w-3.5 h-3.5 text-yellow-400" data-id="element-189" />
            <span className="text-yellow-300 text-xs font-semibold font-sans" data-id="element-190">
              7-Day Guarantee
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-3.5 py-1.5" data-id="element-191">
            <BanknoteIcon className="w-3.5 h-3.5 text-yellow-400" data-id="element-192" />
            <span className="text-yellow-300 text-xs font-semibold font-sans" data-id="element-193">
              One-Time Payment Only
            </span>
          </div>
        </div>

        {/* Animated Payment Icons Runway */}
        <div className="overflow-hidden max-w-xs mx-auto relative" data-id="element-194">
          <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-forest-dark to-transparent z-10" data-id="element-195" />
          <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-forest-dark to-transparent z-10" data-id="element-196" />
          <div className="flex gap-4 w-max animate-payment-slide" data-id="element-197">
            {doubledIcons.map((icon, i) => <div key={i} className="bg-white/10 rounded px-3 py-1.5 border border-white/20 flex-shrink-0" data-id="element-198">
                <span className={`font-sans text-xs font-bold ${icon.color}`} data-id="element-199">
                  {icon.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}